import { render, staticRenderFns } from "./new-list-strategy-row.component.vue?vue&type=template&id=2ca4e25a&scoped=true"
import script from "./new-list-strategy-row.component.vue?vue&type=script&lang=js"
export * from "./new-list-strategy-row.component.vue?vue&type=script&lang=js"
import style0 from "./new-list-strategy-row.component.vue?vue&type=style&index=0&id=2ca4e25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca4e25a",
  null
  
)

export default component.exports